
const ProgramSection = () => {
  const programModules = [
    {
      period: 'Manhã (8h30 - 12h00)',
      title: 'Fundamentos da Reforma Tributária',
      topics: [
        'Histórico e contexto da reforma tributária brasileira',
        'Principais mudanças na legislação 2024/2025',
        'Impactos nos regimes tributários existentes',
        'Cronograma de implementação das mudanças'
      ],
      icon: 'ri-book-open-line'
    },
    {
      period: 'Tarde (13h30 - 17h00)',
      title: 'Aplicação Prática e Casos Reais',
      topics: [
        'Simulações de cálculos com as novas regras',
        'Estudos de caso de empresas reais',
        'Estratégias de planejamento tributário',
        'Compliance e adequação às novas normas'
      ],
      icon: 'ri-calculator-line'
    }
  ];

  const additionalBenefits = [
    {
      icon: 'ri-file-text-line',
      title: 'Material Didático',
      description: 'Apostila completa + planilhas de cálculo'
    },
    {
      icon: 'ri-cup-line',
      title: 'Coffee Break',
      description: 'Networking com outros profissionais'
    },
    {
      icon: 'ri-question-answer-line',
      title: 'Sessão de Q&A',
      description: 'Tire suas dúvidas com especialistas'
    },
    {
      icon: 'ri-download-line',
      title: 'Recursos Digitais',
      description: 'Acesso a templates e ferramentas'
    }
  ];

  return (
    <section id="programa" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Conteúdo Programático
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            8 horas de conteúdo intensivo, dividido em módulos práticos 
            para máximo aproveitamento do seu tempo
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {programModules.map((module, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 border border-blue-200"
            >
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-800 rounded-lg flex items-center justify-center mr-4">
                  <i className={`${module.icon} text-white text-xl`}></i>
                </div>
                <div>
                  <p className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
                    {module.period}
                  </p>
                  <h3 className="text-2xl font-bold text-gray-900">
                    {module.title}
                  </h3>
                </div>
              </div>
              
              <ul className="space-y-3">
                {module.topics.map((topic, topicIndex) => (
                  <li key={topicIndex} className="flex items-start">
                    <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700 leading-relaxed">{topic}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-gray-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Visão de estratégia 
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {additionalBenefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-white text-xl`}></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">
                  {benefit.title}
                </h4>
                <p className="text-gray-600 text-sm">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramSection;
